export interface InspectorQuery {
  userId: string;
  roomId: string;
  sessionId: string;
}
export const emptyInspectorQuery: InspectorQuery = {
  userId: '',
  roomId: '',
  sessionId: '',
};
const uuid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;

function parseRoomLocation(
  input: string,
): Pick<InspectorQuery, 'roomId' | 'sessionId'> {
  const value = input.trim();
  if (!value) return { roomId: '', sessionId: '' };
  if (uuid.test(value)) return { roomId: value.toLowerCase(), sessionId: '' };
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    throw new Error('请输入有效的房间 ID 或房间链接');
  }
  const match = url.pathname.match(
    /^\/(?:share\/v2|platform\/room)\/([^/]+)\/?$/,
  );
  if (
    !['http:', 'https:'].includes(url.protocol) ||
    !match ||
    !uuid.test(match[1])
  )
    throw new Error('请输入有效的房间 ID 或房间链接');
  return {
    roomId: match[1].toLowerCase(),
    sessionId: url.searchParams.get('session') ?? '',
  };
}

export function parseRoomInput(input: string): string {
  return parseRoomLocation(input).roomId;
}

export function parseInspectorQuery(
  input: Partial<InspectorQuery>,
): InspectorQuery {
  const userId = (input.userId ?? '').trim();
  if (userId && !/^[1-9]\d{0,19}$/.test(userId))
    throw new Error('用户 ID 应为数字 UID');
  const room = parseRoomLocation(input.roomId ?? '');
  const roomId = room.roomId;
  const sessionId = (input.sessionId ?? '').trim() || room.sessionId;
  if (sessionId && (!roomId || !/^[\w.-]{1,128}$/.test(sessionId)))
    throw new Error('会话 ID 无效，或尚未选择房间');
  return { userId, roomId, sessionId };
}

export function queryFromURL(params: URLSearchParams): InspectorQuery {
  return parseInspectorQuery({
    userId: params.get('userId') ?? '',
    roomId: params.get('roomId') ?? '',
    sessionId: params.get('sessionId') ?? '',
  });
}
export function queryToURL(
  query: InspectorQuery,
  existing = new URLSearchParams(),
): URLSearchParams {
  const params = new URLSearchParams(existing);
  for (const key of ['userId', 'roomId', 'sessionId'] as const) {
    if (query[key]) params.set(key, query[key]);
    else params.delete(key);
  }
  return params;
}
export function inspectorView(
  query: InspectorQuery,
): 'empty' | 'user' | 'room' {
  return query.roomId ? 'room' : query.userId ? 'user' : 'empty';
}
